(function () {
  var carouselContainer = $(".block-cards-carousel");
  carouselContainer.each(function () {
    var carousel = $(this).find(".cfeeds");
    carousel.slick({
      variableWidth: true,
      prevArrow: $(this).find(".slider-arrow-prev"),
      nextArrow: $(this).find(".slider-arrow-next"),
      infinite: false,
      dots: false,
      focusOnSelect: true,
      focusOnChange: true,
      slidesToShow: 1,
      touchThreshold: 300,
      swipeToSlide: true,
      useTransform: false,
      outerEdgeLimit: true,
      instructionsText:
        "Use the tabs or the back and next buttons to change the displayed slide.",
    });
    var $status = $(".slider-counter");
    carousel.on(
      "init reInit afterChange",
      function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        // use dots to get some count information
        $status.text(i + " / " + slick.slideCount);
      }
    );
    carousel.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        let indicator = carouselContainer.find(".active-indicator");
        if (indicator.length > 0) {
          let indicatorWidth = $(".active-indicator").width();
          $(".active-indicator").css("left", indicatorWidth * nextSlide);
        }
      }
    );
  });
})();
